import resourceService from './resource_service';

const modelName = 'user-role';

const attributes = {};

const relationships = {
  group: {
    jsonApi: 'hasOne',
    update: true,
  },
  role: {
    jsonApi: 'hasOne',
    update: true,
  },
  user: {
    jsonApi: 'hasOne',
  },
};

export default resourceService(modelName, attributes, relationships);
